import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { addASpaceEditToc } from './data/toc';
import { FormattedMessage } from 'react-intl';

const AddASpaceEditToc = ({ spaceId }) => {
  return (
    <div className="EditToc">
      <h2><FormattedMessage id="hosting.add_space_edit_toc.editspace_heading" defaultMessage="Edit your space"/></h2>
      <div className="margin-xl-top">
        {
          map(addASpaceEditToc(spaceId), (item, index) => {
            return (
              <div className="TocRow flex middle">
                <div className="flex-basis-90">
                  <div className="text-large heavy">{index + 1}. {item.header}</div>
                  <div>{item.description}</div>
                </div>
                <div className="flex-basis-10 text-right">
                  <a
                    href={item.link}
                    data-testing-id={item.id}
                    className="btn btn-default btn-outlined-light"
                  ><FormattedMessage id="hosting.add_space_edit_toc.edit_link_text" defaultMessage="Edit"/></a>
                </div>
              </div>
            );
          })
        }
      </div>
      <div className="margin-xl-top text-right">
        <a href='/mylistings' className="btn btn-primary"><FormattedMessage id="hosting.add_space_edit_toc.done_link_text" defaultMessage="Done"/></a>
      </div>
    </div>
  );
};

AddASpaceEditToc.propTypes = {
  spaceId: PropTypes.string
};

export default AddASpaceEditToc;
